<template>
  <div class="app-home-view">
    <div class="app-contents">
      <router-view v-on:prepareCallEvent="prepareCall"/>
    </div>
    <app-navigation/>
    <prepare-call-view
      :modalDisplay="prepareCallDisplay"
      :presentedAttendees="prepareCallAttendees"
      v-on:cancelCallEvent="cancelCall"
      v-on:callStartedEvent="callStarted"
      v-on:parameterErrorEvent="prepareCallFailed"
      />
    <confirm-dialog
      :showDialog="confirmDialogVisible"
      :title="confirmDialogTitle"
      :message="confirmDialogMessage"
      :dialogType="confirmDialogType"
      v-on:negativeResultEvent="confirmFinishNegative"
      v-on:positiveResultEvent="confirmFinishPositive"
      />
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'

import AppNavigation from '@/components/appView/common/AppNavigation.vue'
import PrepareCallView from '@/components/appView/prepareCall/PrepareCallView.vue'

import ConfirmDialog from '@/components/common/ConfirmDialog.vue'

import ConfirmDialogControll from '@/mixin/ConfirmDialogControll'

import * as DIALOG_TYPE from '@/assets/constants/dialogType.js'

export default {
  mixins: [ConfirmDialogControll],

  name: 'AppHomeView',

  components: {
    AppNavigation,
    PrepareCallView,
    ConfirmDialog,
  },

  data () {
    return {
      prepareCallDisplay: false,
      prepareCallAttendees: [],
      exCurrentUser: null,
      exDisplayPage: null,
    }
  },

  mounted() {
    this.loadDatas()
    window.addEventListener('focus', this.handleWindowFocus)
  },

  beforeUnmount () {
    window.removeEventListener('focus', this.handleWindowFocus)
  },  

  watch: {
    '$route': { handler: 'checkPrepareCall', immediate: true },
    currentUser: { handler: 'loadAroundData' }
  },

  computed: {
    ...mapState({
      currentUser: state => state.user.currentUser,
      currentDevice: state => state.user.currentDevice,
      availableUsers: state => state.user.users,
      addressBook: state => state.addressBook.addressCategories,
      callHistories: state => state.callHistory.histories,
    }),

    ...mapGetters({
      favouriteEntries: 'addressBook/favourites',
    }),

    currentSigninName () {
      if (this.currentUser) {
        return this.currentUser.name
      }
      return 'no signin'
    }
  },

  methods: {
    ...mapActions({
      fetchCurrentSignin: 'user/fetchCurrentSignin',
      fetchAvailableUsers: 'user/fetchAvailableUsers',
      switchAccount: 'user/switchAccount',
      fetchAddressBook: 'addressBook/fetch',
      fetchCallHistory: 'callHistory/fetch',
      loadMoreCallHistory: 'callHistory/loadMore',
    }),

    handleWindowFocus () {
      console.log('now, focus-update is ignore for debuging...')
      this.loadDatas()
    },

    checkPrepareCall () {
      console.log(this.$route.path)
      if (this.$route.path === '/phone_call') {
        this.prepareCallDisplay = true
      } else if (this.$route.path === '/app_home') {
        console.log('path watcher, redirect to address_book')
        this.$router.push({ path: '/address_book' })
      }
    },

    loadDatas () {
      console.log('in AppHome, call loadDatas,,,')
      try {
        this.fetchCurrentSignin()
        this.fetchAvailableUsers()
      } catch (error) {
        console.error(error)
        this.showNotifyDialog('インターネット未接続', 'インターネットに接続してないため利用できません。')
      }
    },

    loadAroundData () {
      console.log('in AppHome, load loadAroundData,,,')
      if (this.currentUser) {
        console.log('load datas, current user exist')
        this.fetchAddressBook()
        this.fetchCallHistory()
      }
    },

    loadAddressBook () {
      console.log('load addressbook!')
      if (this.currentUser) {
        console.log('load addressbook, current user exist')
        this.fetchAddressBook()
      }
    },

    prepareCall (account_name, attendees) {
      console.log(attendees)
      if (this.currentUser.account_name !== account_name) {
        this.switchAccount(account_name)
      }
      this.prepareCallAttendees = attendees
      this.prepareCallDisplay = true
    },

    cancelCall () {
      this.prepareCallDisplay = false
      this.prepareCallAttendees = []
      if (this.$route.path === '/' || this.$route.path === '/phone_call') {
        // this.$router.push({ path: '/address_book' })
        this.$router.go(-1)
      }
    },

    callStarted () {
      this.prepareCallDisplay = false
      this.prepareCallAttendees = []
    },

    prepareCallFailed (errorMessage) {
      this.showConfirmDialog(
        '通話準備失敗', 
        errorMessage, 
        DIALOG_TYPE.CONFIRM, 
        () => {
          this.cancelCall()
          // this.$router.push({ path: '/address_book' })
          this.$router.go(-1)
        }
      )
    },
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/global.scss';
@import '@/assets/css/mediaQuery.scss';
@import '@/assets/css/colorTable.scss';

.app-home-view {
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  height: 100vh;
  height: 100dvh;
  .app-contents {
    flex-grow: 1;
    overflow: auto;
    height: calc(100vh - 70px);
    height: calc(100dvh - 70px);
  }
}
</style>